// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatview-top-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid rgb(220, 220, 220);
  height: 100%;
  width: 100%;
}

.chatview-top-bar-title {
  font-family: Roboto, sans-serif;
  color: black;
  flex: 1 0 0%;
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: 10px;
}

.chatview-top-bar-lock {
  margin-left: 8px;
  font-size: 16px;
  color: rgb(222, 72, 88);
}

.chatview-top-bar-lock.unlocked {
  color: rgb(155, 155, 155);
}

.chatview-top-bar-button {
  height: 35px;
  width: 35px;
  margin: 0 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chatview-top-bar-button ion-icon {
  font-size: 24px;
  color: rgb(71, 71, 71);
  pointer-events: none;
}

.chatview-top-bar-button.inactive ion-icon {
  color: rgba(0, 0, 0, 0.3);
}

.editor-top-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  background-color: rgb(242, 242, 242);
}

.editor-avatar-selector {
  position: relative;
  height: 40px;
  width: 40px;
  top: -4px;
  margin: 0 15px;
  cursor: pointer;
}

.editor-avatar-selector.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.editor-avatar-single {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.editor-avatar-first {
  position: absolute;
  width: 28.8px;
  height: 28.8px;
  margin: 0px;
  top: -0.8px;
  left: -0.8px;
  border-radius: 50%;
}

.editor-avatar-second {
  position: absolute;
  width: 28.8px;
  height: 28.8px;
  margin: 0px;
  top: 12px;
  left: 12px;
  border-radius: 50%;
}

/* Placeholder avatars with initials */
.editor-avatar-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.editor-avatar-placeholder-first {
  position: absolute;
  width: 28.8px;
  height: 28.8px;
  margin: 0px;
  top: -0.8px;
  left: -0.8px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}

.editor-avatar-placeholder-second {
  position: absolute;
  width: 28.8px;
  height: 28.8px;
  margin: 0px;
  top: 12px;
  left: 12px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}

.editor-change-avatar-badge {
  position: absolute;
  width: 16px;
  height: 16px;
  bottom: -2px;
  right: -2px;
}

.editor-title-input-container {
  position: relative;
  margin-bottom: 16px;
  top: 8px;
  width: calc(100% - 302px);
}

.editor-title-input-wrapper {
  background-color: white;
  color: rgb(155, 155, 155);
  box-sizing: border-box;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  box-shadow: none;
  transition: box-shadow 450ms cubic-bezier(0.23, 1, 0.32, 1), right 450ms cubic-bezier(0.23, 1, 0.32, 1);
  z-index: 0;
  overflow: hidden;
  height: 32px;
  position: relative;
  width: 100%;
}

.editor-title-input {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  font-size: 16px;
  line-height: 32px;
  margin: 0px;
  padding: 0px 10px 0px 10px;
  border: none;
  outline: none;
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0);
}

.editor-title-input:disabled {
  cursor: not-allowed;
}

.editor-title-input-charcount {
  position: relative;
  left: 10px;
  top: 8px;
  font-size: 12px;
  color: black;
  font-family: Roboto, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  direction: rtl;
  text-align: left;
}

/* ...existing code... */
.editor-buttons {
  position: absolute;
  max-width: 230px;
  float: right;
  right: 20px;
  top: 5px;
  text-align: right;
  padding-top: 10px;
  z-index: 1;
}

.editor-top-bar-button {
  position: relative;
  vertical-align: middle;
  letter-spacing: 0px;
  font-weight: 600;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  text-transform: uppercase;
  color: rgb(222, 72, 88);
  padding: 0 16px;
  cursor: pointer;
}


`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/TopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uGAAuG;EACvG,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".chatview-top-bar {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: white;\n  border-bottom: 1px solid rgb(220, 220, 220);\n  height: 100%;\n  width: 100%;\n}\n\n.chatview-top-bar-title {\n  font-family: Roboto, sans-serif;\n  color: black;\n  flex: 1 0 0%;\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 500;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  padding-left: 10px;\n}\n\n.chatview-top-bar-lock {\n  margin-left: 8px;\n  font-size: 16px;\n  color: rgb(222, 72, 88);\n}\n\n.chatview-top-bar-lock.unlocked {\n  color: rgb(155, 155, 155);\n}\n\n.chatview-top-bar-button {\n  height: 35px;\n  width: 35px;\n  margin: 0 5px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.chatview-top-bar-button ion-icon {\n  font-size: 24px;\n  color: rgb(71, 71, 71);\n  pointer-events: none;\n}\n\n.chatview-top-bar-button.inactive ion-icon {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.editor-top-bar {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%;\n  background-color: rgb(242, 242, 242);\n}\n\n.editor-avatar-selector {\n  position: relative;\n  height: 40px;\n  width: 40px;\n  top: -4px;\n  margin: 0 15px;\n  cursor: pointer;\n}\n\n.editor-avatar-selector.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.editor-avatar-single {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.editor-avatar-first {\n  position: absolute;\n  width: 28.8px;\n  height: 28.8px;\n  margin: 0px;\n  top: -0.8px;\n  left: -0.8px;\n  border-radius: 50%;\n}\n\n.editor-avatar-second {\n  position: absolute;\n  width: 28.8px;\n  height: 28.8px;\n  margin: 0px;\n  top: 12px;\n  left: 12px;\n  border-radius: 50%;\n}\n\n/* Placeholder avatars with initials */\n.editor-avatar-placeholder {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.editor-avatar-placeholder-first {\n  position: absolute;\n  width: 28.8px;\n  height: 28.8px;\n  margin: 0px;\n  top: -0.8px;\n  left: -0.8px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.editor-avatar-placeholder-second {\n  position: absolute;\n  width: 28.8px;\n  height: 28.8px;\n  margin: 0px;\n  top: 12px;\n  left: 12px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.editor-change-avatar-badge {\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  bottom: -2px;\n  right: -2px;\n}\n\n.editor-title-input-container {\n  position: relative;\n  margin-bottom: 16px;\n  top: 8px;\n  width: calc(100% - 302px);\n}\n\n.editor-title-input-wrapper {\n  background-color: white;\n  color: rgb(155, 155, 155);\n  box-sizing: border-box;\n  border-radius: 5px;\n  text-align: center;\n  font-size: 16px;\n  box-shadow: none;\n  transition: box-shadow 450ms cubic-bezier(0.23, 1, 0.32, 1), right 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  z-index: 0;\n  overflow: hidden;\n  height: 32px;\n  position: relative;\n  width: 100%;\n}\n\n.editor-title-input {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 32px;\n  font-size: 16px;\n  line-height: 32px;\n  margin: 0px;\n  padding: 0px 10px 0px 10px;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.editor-title-input:disabled {\n  cursor: not-allowed;\n}\n\n.editor-title-input-charcount {\n  position: relative;\n  left: 10px;\n  top: 8px;\n  font-size: 12px;\n  color: black;\n  font-family: Roboto, sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  direction: rtl;\n  text-align: left;\n}\n\n/* ...existing code... */\n.editor-buttons {\n  position: absolute;\n  max-width: 230px;\n  float: right;\n  right: 20px;\n  top: 5px;\n  text-align: right;\n  padding-top: 10px;\n  z-index: 1;\n}\n\n.editor-top-bar-button {\n  position: relative;\n  vertical-align: middle;\n  letter-spacing: 0px;\n  font-weight: 600;\n  font-size: 14px;\n  font-family: Roboto, sans-serif;\n  text-transform: uppercase;\n  color: rgb(222, 72, 88);\n  padding: 0 16px;\n  cursor: pointer;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
